import { render, staticRenderFns } from "./ApplicationofFunds202011D20.vue?vue&type=template&id=1f73cbf3&scoped=true&"
import script from "./ApplicationofFunds202011D20.vue?vue&type=script&lang=js&"
export * from "./ApplicationofFunds202011D20.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationofFunds202011D20.vue?vue&type=style&index=0&id=1f73cbf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f73cbf3",
  null
  
)

export default component.exports